<template>
    <div id="protocol_root" class="protocol">
        <div class="cover_box"></div>
        <div class="main_box">
            <h1>《StudyArts用户服务协议及隐私政策》</h1>
            <br>
            <br>
            <br>
            <p>
                <span></span>
                在您下载、安装或使用StudyArts APP产品及任何随附的文档（如有），
                包括提供给您的更新或升级版本（依据本协议之外的其他协议提供给您的更新或升级版本除外）（下文统称“StudyArts”）之前，请您务必仔细阅读本协议中约定的下述条款。
            </p>
            <p>
                <span></span>
                除非您与爱德森（大连）科技有限公司（以下简称“公司”）就StudyArts的使用另外签署了其他协议，否则您对StudyArts的使用受本《StudyArts用户服务协议及隐私政策》（以下简称“本协议”）中各项条款的约束。
            </p>
            <p>
                <span></span>
                请您仔细阅读以下条款，在您同意并接受本协议全部条款的前提下，公司将StudyArts的合法使用授权授予您。
                如果您是未成年人，则请您在法定监护人陪同下审阅和判断是否同意本协议，未成年人使用StudyArts的行为视为已获得了法定监护人的认可。
                如果您不同意接受本协议的全部条款，则您无权注册、登录或使用本协议所涉及服务，您下载、安装、使用StudyArts等行为，
                则意味着您将自愿遵守本协议及StudyArts的其他有关规则，并完全服从于StudyArts的统一管理。
            </p>
             <p>
                <span></span>
                StudyArts有权根据业务需要对本协议不定时进行调整，并将调整后的协议公布于公司官网或者StudyArtsAPP中，如果您不同意调整后的本协议的，您应当停止使用StudyArts，
                否则，如果在公司调整本协议并公布后，您继续使用StudyArts提供的服务的，则视为您同意遵守调整后的协议。
            </p>
            <h3>一、用户的权利与义务</h3>
             <p>
                <span></span>
                 1.用户须通过合法渠道（包括但不限于各大应用市场、StudyArts官网）下载、安装并使用StudyArts，这是您获得StudyArts使用授权的前提。
            </p>
            <p>
                <span></span>
                2. 用户一经注册或登录使用StudyArts，即视为用户同意公司或其关联公司的工作人员与其进行电话或短信联系。
            </p>
            <p>
                <span></span>
                3.使用StudyArts时产生的通讯流量费用由用户自行承担。
            </p>
            <p>
                <span></span>
                4.用户应妥善保管自己的账号、密码，不得转让、出借、出租、出售或分享予他人使用。
                否则StudyArts有权根据实际情况暂时封停或永久查封此账号，当用户的账号或密码遭到未经授权的使用时，用户应当立即通知StudyArts，否则未经授权的使用行为均视为用户本人行为。
            </p>
            <p>
                <span></span>
                5.公司有权随时对StudyArts提供的服务内容等进行调整，包括但不限于增加、删除、修改StudyArts服务内容，一旦StudyArts的服务内容发生增加、删除、修改，StudyArts将在相关页面上进行提示；
                如果用户不同意相关变更和修改，可以取消已经获取的服务并停止使用；如果用户继续使用StudyArts提供的服务，则视为用户已经接受全部变更、修改。
                除非另有明确约定，否则用户使用StudyArts内新增的服务内容将同样受本协议各项条款的约束。
            </p>
            <p>
                <span></span>
               6.StudyArts内提供的服务分为免费服务和收费服务。对于现阶段免费提供的服务内容，公司有权随时根据公司政策的调整将其变更为收费服务，如果发生该等变更的，公司将提前告知用户，如果用户不同意的，可以停止使用该服务。
               对于收费的服务内容，公司有权自行确定该等服务的价格并不时调整，调整后的价格将在StudyArts平台中进行公示，如果用户不同意调整后的价格的，则用户可以在其原购买的收费服务到期后停止付费购买收费服务。
               如果用户在公司调整价格并公示后，仍继续购买收费服务的，则视为用户同意该调整后的价格。 
            </p>
            <p>
                <span></span>
               7.公司禁止以任何形式倒卖、贩售、出租、出借、转让用户账号、优惠券或折扣等其他优惠方式及使用第三方渠道（即非StudyArts官方渠道）代充行为，一经查明，公司将采取包括但不限于封号、封禁IP、追究相关责任人法律责任的处理措施。 
            </p>
            <h3>二、平台管理</h3>
            <p>
                <span></span>
                1.StudyArts存在专门的审核团队对用户使用StudyArts的行为进行监督和审核，用户也可通过联系我们的方式对使用过程中发现的不良内容进行举报。一旦发现作弊及发布违反StudyArts规定的行为，我们将对违规用户进行处理。
            </p>
            <p>
                <span></span>
                2.在StudyArts产品使用期间，公司有权删除不符合法律法规、部门规章、公序良俗的问答、评论、帖子等，以及公司认为跟StudyArts产品和服务不相关或者认为不适当、不合理的用户内容，
                包括但不限于，含有色情、暴力、恐怖内容，具有广告性质，含有反动内容，含有人身攻击内容，含有违背伦理道德内容，具有恶意、无聊和灌水性质，涉及违法犯罪的内容，以及其他违反法律及StudyArts平台管理制度的内容。
            </p>
            <p>
                <span></span>
                3.对账号的管理原则
            </p>
            <p>
                <span></span>
               （1）您应保证您注册、登录并使用的账号符合中国相关法律法规的规定，符合《互联网用户账号名称管理规定》，符合本协议的各项规定。公司有权对您注册、登录并使用的账号名称、头像和简介等注册信息进行审核，您确保您登录本软件使用的用户账号名称、头像和简介等信息中不得出现违法和不良信息，不存在以虚假信息骗取账号名称注册的情形；
               您应确保您登录StudyArts使用的用户账号名称不得为您冒用关联机构或社会名人注册的账号名称。
            </p>
            <p>
                <span></span>
                （2）如果您以虚假信息骗取账号名称注册，或您的账号头像、简介等注册信息存在违法和不良信息的，公司有权采取通知限期改正、暂停使用、注销登记等措施；如果您冒用关联机构或社会名人注册账号名称的，公司有权注销您的账号，并向互联网信息内容主管部门报告。
            </p>
            <p>
                <span></span>
                （3）凡用户存在作弊行为，发布广告，发布黄色、反动内容，发布不文明内容，抄袭，模仿管理人员ID，用以假冒管理人员或破坏管理人员形象，模仿或盗用他人ID 个人签名，发布的内容包含有严重影响网友浏览的内容或格式，或者存在其他扰乱StudyArts秩序的，或影响StudyArts一课正常经营行为的，公司有权删除其相应账号，情节严重者，将酌情封禁对应IP。
            </p>
            <h3>
                三、知识产权
            </h3>
            <p>
                <span></span>
                1.公司拥有StudyArts的所有权，包括其中的知识产权。StudyArts受中华人民共和国著作权法的保护，用户不得删除或以其他方式改变StudyArts上附带的版权、商标或其他所有权声明或标识。用户不得对StudyArts进行反向工程、反向编译或反汇编，不得试图进行任何获得StudyArts源代码的访问或行为，不得发行、出租、信息网络传播、翻译StudyArts软件。
            </p>
            <p>
                <span></span>
               2.StudyArts的用户不能侵犯包括他人的著作权在内的知识产权以及其他权利。一旦由于用户的提问、回答、发言发生法律纠纷，其责任在于用户本人，与StudyArts及公司无关。  
            </p>
            <p>
                <span></span>
               3.对于用户发表到StudyArts上的任何内容，用户同意StudyArts在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。
               并且，用户许可StudyArts公司有权利就任何主体侵权而单独采取法律行动（包括但不限于诉讼、举报、律师函等形式）。  
            </p>
            <p>
                <span></span>
               4.StudyArts用户的言论侵犯了第三方的著作权或其他权利，第三方提出异议的时候，StudyArts有权删除相关的内容，提出异议者和用户之间以和解、调解、仲裁、诉讼等方式解决了争议后，以此为依据，StudyArts在得到有关申请后可以恢复被删除的内容。 
            </p>
            <p>
                <span></span>
              5.用户从StudyArts的服务中获得的信息在没有得到事先许可的情况下，自行或提供给第三方利用复制，发送，传播等手段用于盈利目的时，将追究相关当事人的法律责任。  
            </p>
            <p>
                <span></span>
                 6.未经本公司事先许可，禁止使用任何机器人、爬虫程序、其他自动设备，或手动程序等来监视或复制StudyArts网页或其所包含的任何内容。否则，StudyArts有权依法追究法律责任。
            </p>
            <p>
                <span></span>
                7.如果第三方要使用StudyArts上的提问、回答或评论的，则需要事先获得相关用户同意后方能使用。
            </p>
            <h3>
                四、不允诺担保、责任有限及免责
            </h3>
            <p>
                <span></span>
               1.不允诺担保：StudyArts用户提问、回答、发言仅代表用户个人观点，与公司无关，且StudyArts不对用户发表的回答或评论的正确性、准确性、真实性进行保证。StudyArts为按现状提供，包含瑕疵及缺陷，公司不提供任何其他担保。
               公司不允诺其他无论是明示的还是默示的保证和担保，包括但不限于对特定目的的适销性和适应性，不侵权，以及任何出自交易过程或商业惯例的保证和条件。
               从公司或他处获取的任何建议或信息，不论是口头的还是书面的，都不会对公司产生本协议明确约定之外的其他保证和担保。 
            </p>
            <p>
                <span></span>
                2.责任有限：适用法律所允许的最大范围内，不论出于何种原因，公司对您的全部责任为您为使用StudyArts的产品和服务而向公司支付的费用总额。
                如果公司免费向您提供了StudyArts服务，则公司无义务对您承担任何赔偿责任。
                任何情况下，公司不对出自本协议或与本协议有关的或与StudyArts的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，
                不论该等责任是基于合同，担保，侵权（包括过失），严格责任或其他，也不论公司是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。
            </p>
            <p>
                <span></span>
                3.免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，公司均有权获得免责：
            </p>
            <p>
                <span></span>
                （1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；
            </p>
            <p>
                <span></span>
                （2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；
            </p>
            <p>
                <span></span>
                （3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；
            </p>
            <p>
                <span></span>
                （4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；
            </p>
            <p>
                <span></span>
                （5）其他不能归责于公司的原因。
            </p>
            <h3>
                五、用户隐私声明
            </h3>
            <p>
                <span></span>
                1.公司仅出于向用户提供更优质、更个性化服务的目的收集用户的信息，且，公司重视未成年人的个人信息保护，如您为未成年人，请务必由您的监护人仔细阅读本隐私条款，并在征得监护人同意的前提下使用StudyArts或向StudyArts提供相关用户信息。
            </p>
            <p>
                <span></span>
               2.在用户使用StudyArts的过程中，公司将遵循合法、正当、必要的原则，收集用户使用StudyArts的相关信息，包括但不限于：  
            </p>
            <p>
                <span></span>
                （1）用户注册或登录的账户信息，例如用户注册账户使用的电话号码、姓名或昵称，用户自行填写的班级、学校等；
            </p>
            <p>
                <span></span>
                （2）用户上传的信息，例如用户的发帖、评论、分享、用户主动填写的信息或用户与StudyArts客服联系时提供的相关信息等；
            </p>
            <p>
                <span></span>
                （3）用户使用StudyArts过程中产生的信息。公司会根据用户授予的权限，接收并记录用户所使用的设备相关信息，例如设备属性信息、设备位置信息、设备连接信息等；
            </p>
            <p>
                <span></span>
                （4）StudyArts根据用户授权通过合法方式收集的其他用户信息。
            </p>
            <p>
                <span></span>
                 3.公司非常重视用户的信息安全，并尽最大合理努力采取各种合理的物理、电子和管理方面的安全措施来保护用户信息，确保用户信息不会被泄漏、篡改、毁损或丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制、信息访问权限控制等。
                 且，公司不会非法出售、非法向他人提供用户信息；公司不会将用户的该等信息提供给任何非必要的第三方，也不会用于任何其他目的和用途，但是以下情形除外：
            </p>
            <p>
                <span></span>
                （1）经用户事先同意，向第三方披露；
            </p>
            <p>
                <span></span>
                （2）根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
            </p>
            <p>
                <span></span>
                （3）公司与第三方合作向用户提供StudyArts平台的相关服务或其他网络服务，且该等第三方同意承担与公司同等的保护用户隐私的责任；
            </p>
            <p>
                <span></span>
               （4）其他根据法律、法规或者政策应进行的披露。 
            </p>
            <h3> 六、其他</h3>
            <p>
                <span></span>
              1.如果StudyArts平台上某一子服务附有单独的使用协议的，则该子服务的使用将受该单独使用协议的约束。  
            </p>
            <p>
                <span></span>
              2.本协议的签订、生效、履行、争议的解决均适用中华人民共和国法律。  
            </p>
            <p>
                <span></span>
              3.有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交公司所在地有管辖权的法院诉讼解决。  
            </p>
            <br>
            <br>
            <br>
            <h4>爱德森（大连）科技有限公司</h4>
            <br>
            <br>
            <h4 style="color:#02ADFF">辽ICP备19008843号</h4>
            <p>
                <span></span>
                
            </p>
            <p>
                <span></span>
                
            </p>
        </div>        
    </div>
</template>
<script>
export default {
    data(){
        return;
    },
    mounted(){

    },
    methods:{
    goHome: function() {
      this.$router.push("/");
    },        
    }
}
</script>
<style scoped>
.protocol{
    background-color: #6f6f6f;
    padding: 20px 10px;
}

.main_box{
    background-color: #f0f0f0;
    margin: 0 auto;
    /* min-width: 500px; */
    max-width: 900px;
    text-align: center;
    padding: 20px 10px;
}
.protocol .main_box p,.protocol .main_box h3{
    text-align: left;
    user-select: none;
}
.protocol .main_box p span{
    margin-left: 2em;
}
.protocol .main_box h4{
    text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/views/index/userProtocol.vue